module.exports = "<span class=\"kl-tag kl-tag--{type}\">\n  {#inc this.$body}\n  {#if closable}\n    <kl-icon class=\"kl-tag__close\" type=\"cross\" on-click={this.close($event)} />\n  {/if}\n</span>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/common/KLTag/index.html
// module id = 394
// module chunks = 0